import { useEffect, useMemo } from "react";
import Dropdown from "../../../../components/misc/Dropdown";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { fetchFleet } from "../../../../redux/api/fleet.api";

function AutoBarcode({
  selectedValue,
  setSelectedValue,
}: {
  selectedValue: any;
  setSelectedValue: any;
}) {
  const dispatch = useAppDispatch();

  const {
    fleet: {
      fleetData: {
        data: { data: fleetData },
      },
    },
  } = useAppSelector((state) => ({
    fleet: state.fleet,
  }));

  useEffect(() => {
    dispatch(
      fetchFleet({
        perPage: 10000,
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    if (fleetData.length) {
      setSelectedValue({
        id: fleetData[0]?.id_auto,
        label: fleetData[0]?.nrauto,
      });
    }
  }, [fleetData, setSelectedValue]);

  const fleetNomenclaturesDropdownValues = useMemo(
    () =>
      fleetData?.map((item) => ({
        label: item.nrauto,
        id: item.id_auto,
      })),
    [fleetData],
  );

  const handleSelectValue = (value: any) => {
    setSelectedValue(value);
  };

  return (
    <Dropdown
      className="my-4 mt-10"
      title="Masini"
      data={fleetNomenclaturesDropdownValues}
      singleValue={{
        id: selectedValue?.id || "",
        label: selectedValue?.label || "",
      }}
      setSingleValue={handleSelectValue}
    />
  );
}

export default AutoBarcode;
